import { JsqProductHS } from 'src/commons/store/UserStore'
import { AppStore } from 'src/pc/store/AppStore'
import { useEffect, useMemo } from 'react'
import { runSpeedClient } from 'src/pc/pages/booster'

/**
 * 默认加速器（寒光）下载
 * @param switcher
 */
const useRunDefaultSpeed = (switcher?: boolean) => {
  const jsqProductList = JsqProductHS.SuccessResult
  const { SpeedClientInstallStatus, SpeedClientDownloadProgress } = AppStore
  //默认下载的加速器信息
  const defaultSpeed = jsqProductList?.find(value => value.properties.isDefault === '1')?.properties
  const productId = defaultSpeed?.productid
  const downloadPercent = (productId && SpeedClientDownloadProgress[productId]) || 0
  //加速器下载中
  const isDownloading = productId && downloadPercent > 0 && downloadPercent < 100
  //加速器启动中
  const isStarting = productId && SpeedClientInstallStatus[productId] === 2
  //加速器已启动
  const isStarted = productId && SpeedClientInstallStatus[productId] === 1

  // useEffect(() => {
  //   if (!switcher || jsqProductList) {
  //     return
  //   }
  //   JsqProductHS.Execute()
  // }, [switcher, jsqProductList])

  return {
    defaultSpeed,
    productId,
    downloadPercent,
    isDownloading,
    isStarting,
    isStarted,
    runSpeedClient,
  }
}

export default useRunDefaultSpeed
